import { config, styled } from 'design'
import React from 'react'

import { container } from './shared'

const CHILD_SELECTOR = '> *'

// Generate 'gap' prop values from theme config
const { space } = config.theme
type SpaceKey = keyof typeof config.theme.space

const gap = Object.keys(space).reduce(
  (acc, spaceKey) => ({
    ...acc,
    [spaceKey]: {
      gap: space[spaceKey],
    },
  }),
  {},
) as { [key in SpaceKey]: any }

export const Stack = styled('div', {
  display: 'flex',
  listStyleType: 'none',
  ...container,
  [CHILD_SELECTOR]: {
    margin: 0,
  },
  variants: {
    direction: {
      row: {
        flexDirection: 'row',
        alignItems: 'center',
      },
      'row-reverse': {
        flexDirection: 'row-reverse',
        alignItems: 'center',
      },
      column: {
        flexDirection: 'column',
      },
      'column-reverse': {
        flexDirection: 'column-reverse',
      },
    },
    gap,
  },
  defaultVariants: {
    gap: 0,
    direction: 'column',
  },
})

export type StackProps = {
  gap?: SpaceKey
  direction?: 'row' | 'column'
} & React.ComponentProps<typeof Stack>
